import { ISearchFacet, ISearchHit } from "data/searchManager/interfaces/ISearch"

export interface ISearchState {
    query: string
    totalHits: number
    searchResultList: ISearchHit[] | undefined
    selectedFacet: string
    initialFacets: ISearchFacet[]
    skip: number
    sortType: number
    shouldFetch: boolean
}

type ACTIONTYPE =
    | {
          type: "NEW_SEARCHQUERY"
          payload: string
      }
    | { type: "TRIGGER_LOAD_MORE"; payload: number }
    | {
          type: "NEW_SEARCHRESULT"
          payload: {
              totalHits: number
              searchResultList: ISearchHit[]
          }
      }
    | { type: "LOAD_MORE_SEARCHRESULTS"; payload: ISearchHit[] }
    | {
          type: "PICK_FACET"
          payload: string
      }
    | {
          type: "SET_INITIAL_FACETS"
          payload: ISearchFacet[]
      }
    | {
          type: "PICK_SORT_TYPE"
          payload: number
      }

export function searchReducer(state: ISearchState, action: ACTIONTYPE) {
    switch (action.type) {
        case "NEW_SEARCHQUERY":
            return {
                ...state,
                query: action.payload,
                initialFacets: [] as ISearchFacet[],
                shouldFetch: true
            }
        case "TRIGGER_LOAD_MORE":
            return {
                ...state,
                skip: action.payload,
                shouldFetch: true
            }
        case "NEW_SEARCHRESULT":
            return {
                ...state,
                totalHits: action.payload.totalHits,
                searchResultList: action.payload.searchResultList,
                shouldFetch: false
            }
        case "LOAD_MORE_SEARCHRESULTS":
            return {
                ...state,
                searchResultList: [
                    ...(state.searchResultList ?? []),
                    ...action.payload
                ],
                shouldFetch: false
            }
        case "PICK_FACET":
            return {
                ...state,
                sortType: 0,
                selectedFacet: action.payload,
                shouldFetch: true
            }

        case "SET_INITIAL_FACETS":
            return {
                ...state,
                initialFacets: action.payload,
                selectedFacet: "",
                shouldFetch: false
            }
        case "PICK_SORT_TYPE":
            return {
                ...state,
                sortType: action.payload,
                skip: 0,
                shouldFetch: true
            }
        default: {
            const { type } = action
            throw new Error(
                `The action type ${type} is not defined in the searchReducer`
            )
        }
    }
}
